import { ContainerHeader } from 'shared/ui'
import { ConversationSearchHeaderContent } from 'widgets/ConversationNew/ui/ConversationSearchHeader/ConversationSearchHeaderContent'
import styles from './styles.module.scss'

export const ConversationSearchHeader = () => {
  return (
    <ContainerHeader
      type={'container'}
      container={<ConversationSearchHeaderContent />}
      isBorderBottom
      isAutoHeight
      className={styles.header}
    />
  )
}
